import styled from '@emotion/styled';

const MealPlannerLegends = {
  List: styled.ul`
    display: flex;
    justify-content: space-between;
    list-style: none;

    width: 100%;
    height: 20px;

    padding: 0;
    margin: 0;
    margin-bottom: 8px;
  `,
  Item: styled.li`
    display: flex;
    align-items: center;
  `,
};

export default MealPlannerLegends;
